import React from 'react';
import TextField from './TextField';

/**
 * Reusable Phone Number Input Field Component
 * Specialized phone field with validation
 * 
 * @param {boolean} readOnly - Whether field is read-only
 * @param {string} placeholder - Custom placeholder text
 * @param {string} name - Field name (defaults to 'phoneNumber')
 * @param {object} ...props - Additional props passed to TextField
 */
const PhoneField = ({ 
  readOnly = false, 
  placeholder = "e.g +234 701 234 5678",
  name = "phoneNumber",
  ...props 
}) => (
  <TextField
    name={name}
    label="Phone Number"
    placeholder={placeholder}
    type="tel"
    required
    readOnly={readOnly}
    rules={[
      { pattern: /^[\+]?[0-9\s\-\(\)]{10,15}$/, message: 'Please enter a valid phone number' },
      { min: 11, message: 'Phone number must be at least 11 digits' },
      { max: 11, message: 'Phone number must not exceed 11 digits' }
    ]}
    {...props}
  />
);

export default PhoneField;
